import React, { useState } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useDossierCustomHeader } from '@europrocurement/l2d-modules';

const DossierDocumentsValidationCustomHeader: React.FunctionComponent = function () {
    const { palette } = useTheme();
    const [processing, setProcessing] = useState<boolean>(false);
    const { onExit, headerTitle, headerButton, actionsBloc } = useDossierCustomHeader();

    const handleClick = () => {
        if (onExit) {
            setProcessing(true);
            onExit();
        }
    };

    const goBackBtnSx = {
        borderColor: palette.grey[300],
        display: 'flex',
        gap: '0 8px',
        alignItems: 'center',
        padding: '8px 16px',
        borderRadius: '60px',
        color: palette.grey[500],
        marginLeft: 'auto',
        marginRight: '40px',

        '&:hover': {
            borderColor: palette.grey[500],
            color: palette.grey[600],
        },
    };

    const goBackBtnIconSx = {
        display: 'flex',
        alignItems: 'center',
        lineHeight: 0,
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
            }}
        >
            <Typography
                variant="l2dh7"
                sx={{ color: palette.secondary.main }}
            >
                {headerTitle || 'Vérifier les informations du dossier'}
            </Typography>

            <Box sx={{ display: 'flex' }}>
                {actionsBloc}

                <Button
                    sx={goBackBtnSx}
                    onClick={handleClick}
                    variant="outlined"
                    disabled={processing}
                >
                    <FaOptionIcon
                        sx={goBackBtnIconSx}
                        icon={['fasl', 'times']}
                    />
                    <Typography variant="caption">
                        {headerButton || 'Enregistrer et quitter'}
                    </Typography>
                </Button>
            </Box>
        </Box>
    );
};

export default DossierDocumentsValidationCustomHeader;
